<template>
  <el-container class="indexman">
    <el-header>
      <!-- 头部 -->
      <el-header v-if="$route.path !== '/examination/Answer'">
        <AppHeader ref="appHeader" :types="'ks'" />
      </el-header>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <!-- 导航栏 -->
        <Menus :issleectname.sync="issleectname" ref="aside" :reload="reload" />
      </el-aside>
      <el-main>
        <!-- 设置子路由出口 -->
        <div class="fff">
           <router-view></router-view>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AppHeader from "../layout/components/AppHeader.vue";
import Menus from "./components/Menus.vue";
import menuList from "@/router/routerList";

export default {
  data() {
    return {
      title: [], // 面包屑数组
      issleectname: "", //当前选中的路由
    };
  },
  methods: {
    reload() {
      //刷新主页路由的办法
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    //面包屑
    navchange(e) {
      this.isnav = e;
      this.issleectname = this.title[e].routername;
      const b = this.title[e].routername;
      this.$router.push({ name: b });
    },
    navclose(e) {
      if (this.title.length == 1) {
        this.$message({
          message: "警告，当前是最后一个面包屑",
          type: "warning",
        });
      } else {
        this.title.splice(e, 1);
        this.$refs.aside.isActiveTitle.splice(e, 1);
      }
    },
    //  添加路由的方法有两个属性，一个是标签的中文名，展示路由导航，一个是router的name
    addNavBottom(name, routername) {
      const addtitle = { name: "", routername: "" };
      addtitle.name = name;
      addtitle.routername = routername;
      this.title.push(addtitle);
    },
  },
  components: {
    AppHeader,
    Menus,
  },
  computed: {
    isnav() {
      return this.title.indexOf(
        // this.title.filter((d) => d.routername === this.$route.name)[0]
        // 此处逻辑改为，如果当前路由名包含title的routername
        this.title.filter((item) => {
          if (item.routername.substr(-4) === "Page") {
            item.routername = item.routername.substr(
              0,
              item.routername.length - 4
            ); // 截取后面的page
          }
          if (this.$route.name.indexOf(item.routername) != -1) {
            // 如果子路由包含父路由名称
            return item;
          }
        })[0]
      );
    },
    breadcrumbList() {
      let arr = this.$route.matched;
      const obj = {};
      arr = arr.reduce((total, next) => {
        obj[next.meta.name]
          ? ""
          : (obj[next.meta.name] = true && total.push(next));
        return total;
      }, []);
      console.log(arr,'arr');
      return arr;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$refs.aside.isActiveTitle.indexOf(to.meta.name) !== -1) {
        return;
      }
      if (to.name === "home") {
        vm.addNavBottom("主页", to.name); //添加一个面包屑
        vm.$refs.aside.isActiveTitle.push("主页");
      } else {
        vm.addNavBottom(to.meta.name, to.name); //添加一个面包屑
        vm.$refs.aside.isActiveTitle.push(to.meta.name);
      }
      //   }
    });
  },
  mounted() {},
  created() {
    this.$root.$Navbottom = this.addNavBottom;
    // console.log(this.$route.path == "/examination/table");
  },
};
</script>

<style lang="scss" scoped>
.el-header {
  color: #333;
  text-align: center;
  padding: 0 !important;
  height: 100px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid #3388ff;
}

// .el-container {
//   height: 100vh;
//   min-width: 1572px !important;
//   display: flex;
//   flex-direction: column;
//   position: relative;
// }
.center {
  height: 100%;
  width: 100%;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
.el-container {
  height: calc(100vh - 80px);
  min-width: 1572px !important;
  position: relative;
}
.indexman {
  height: 100vh;
}
::v-deep .el-aside {
  background-color: #ebecf1;
  width: 230px !important;
  height: 100%;
  transition: all 0.3s;
  &::-webkit-scrollbar {
    display: none;
  }
  .el-menu-item .is-active {
    color: #fff !important;
  }
  .is-active {
    color: rgb(183, 189, 198);
    // font-size: 16px;
    font-weight: bolder;
    // background: #000000 !important;
  }
}
.fff {
  background: #ffffff !important;
}
.el-main {
  // background-color: #f8f8f8;
  // border: 1px solid #000;
  // min-height: 888px;
  // padding: 0px 0px 0px 24px !important;
  // border: 1px solid red;
  // &::-webkit-scrollbar {
  //   display: none; // 全局项目滚动条隐藏*/
  // }
  background: #ebecf1;
  padding-left: 26px;
  // padding: 0 !important;
  // margin-bottom: 40px;
  border-radius: 0px 0px 4px 4px;
}
.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 10px;
  }
  h4 {
    color: #fff;
  }
}
::v-deep .el-container {
  width: 100% !important;
}
// .el-header {
//   background: #0084ea;
//   background-size: 100% 100%;
//   background-repeat: no-repeat;
//   height: 80px !important;
//   display: flex;
//   align-items: center;
// }
// 面包屑
.mian_nav {
  height: 44px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  background-color: #fff;
  // border-top-left-radius: 10px;
  // border-top-right-radius: 10px;
}
.nav_title {
  width: 146px;
  height: 100%;
  //background-color: red;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #d9d9d9;
  background: #eeeeee;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  &:nth-child(1) {
    // border-top-left-radius: 10px;
    border-left: 1px solid #d9d9d9;
  }
  h4 {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 26px;
    color: #4d4d4d;
    cursor: pointer;
  }
  img {
    margin-left: 21px;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
}
.isnav_title {
  background-color: rgb(255, 255, 255);
  border-top: 3px solid #08c6bb;
  border-bottom: none;
  border-left: none !important;
}
.breadcrumb {
  // background: #ebecf1;
  // padding-left: 26px;
  .nav_one {
    height: 60px;
    background: #ebecf1;
    display: flex;
    align-items: center;
  }
}
</style>